var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_30)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53369 0.0100622H18.4102L20.4325 3.71462H24.5992C24.821 3.71462 25.002 3.90718 25.002 4.12903V18.5873C25.002 18.8091 24.8169 19.0017 24.5992 19.0017H0.402832C0.187175 18.9996 0 18.8133 0 18.5873V4.12903C0 3.9009 0.181071 3.71462 0.402832 3.71462H2.27661V2.38559H4.59188V3.71462H7.10653C7.6294 2.65139 8.15226 1.59026 8.67513 0.527026C8.99251 -0.119702 8.81755 0.0100622 9.53369 0.0100622ZM22.3938 5.54597C23.0571 5.54597 23.5942 6.09852 23.5942 6.78083C23.5942 7.46314 23.0571 8.01568 22.3938 8.01568C21.7306 8.01568 21.1934 7.46314 21.1934 6.78083C21.1955 6.09852 21.7326 5.54597 22.3938 5.54597ZM13.5579 6.98385C15.566 6.98385 17.1956 8.66032 17.1956 10.7261C17.1956 12.7918 15.566 14.4683 13.5579 14.4683C11.5499 14.4683 9.92025 12.7918 9.92025 10.7261C9.92025 8.66032 11.5499 6.98385 13.5579 6.98385ZM13.5579 4.54763C16.8762 4.54763 19.5658 7.31453 19.5658 10.7282C19.5658 14.1397 16.8762 16.9087 13.5579 16.9087C10.2417 16.9087 7.55005 14.1397 7.55005 10.7282C7.55208 7.31453 10.2417 4.54763 13.5579 4.54763Z",
    fill: "#B99750"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIconCheck);
export default __webpack_public_path__ + "static/media/camera-icon-check.94352f0771a78347a3daf42162417d17.svg";
export { ForwardRef as ReactComponent };